import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import axios from 'axios'
import SkeletonLoader from './Loaders/SkeletonLoader'

const Categories = () => {
    const [categorySets, setCategorySets] = useState()

    const getCategories = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API_URL + '/site', {
                params: {
                    database: 'suchomel',
                    table: 'categorySets'
                },
                headers: {
                    Authorization: process.env.REACT_APP_API_KEY
                }
            })
            setCategorySets(response.data)
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getCategories()
    }, [])

    return (
        <div className="wrapper">
            <h2 className='wrapper__heading'>Kategorie na webu</h2>
            <div className="wrapper__list">
                <ul>
                    {!categorySets &&
                        [...Array(3)].map((e, i) => {
                            return <SkeletonLoader key={i} />
                        })
                    }
                    {categorySets?.map(set => {
                        return <li key={set.id}><Link to={'/category/' + set.id}>{set.name}</Link></li>
                    })}
                </ul>
            </div>
        </div>
    )
}

export default Categories